import { PrimeReactProvider } from "primereact/api";
import { Outlet } from "react-router-dom";
import {
  ConfirmDialogProvider,
  DetailPanelProvider,
  LoaderSpinnerProvider,
  SnackbarProvider,
} from "providers";
import { AxiosInterceptor } from "utils/AxiosInterceptor";

function App() {
  return (
    <PrimeReactProvider>
      <LoaderSpinnerProvider>
        <ConfirmDialogProvider>
          <SnackbarProvider>
            <DetailPanelProvider>
              <AxiosInterceptor>
                <Outlet />
              </AxiosInterceptor>
            </DetailPanelProvider>
          </SnackbarProvider>
        </ConfirmDialogProvider>
      </LoaderSpinnerProvider>
    </PrimeReactProvider>
  );
}

export default App;
